// extracted by mini-css-extract-plugin
export var infoRow = "_o4-2";
export var labelContainer = "_o4-0";
export var rightInfo = "_o4-1";